/*
 * This illustrates how to modify the LoadOrdersHandler in a number of different ways.
 * The LoadOrdersHandler is used by the order history page to load order data
 */

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";

import {
    chain,
    RemoveAllFilters,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

export const RemoveMyBranchFilter = (props: any) => {
    props.result.stockedMyBranch = undefined;
};
addToChainAfter(chain, RemoveAllFilters, RemoveMyBranchFilter);
// trying to reference a handler not in the chain will result in a warning and the chain will not be modified

